import { gql } from "@apollo/client";

// ============================================================================
// BASIC PAGES QUERIES
// ============================================================================

import { GENERAL_FIELDS, SITE_FIELDS, PAGE_SETTINGS } from "./shared";
import { SECTIONS_WRAPPER_QUERY } from "./fragments/sections";

// Contact Pages
export const CONTACT_QUERY = gql`
  ${SITE_FIELDS}
  ${GENERAL_FIELDS}
  ${PAGE_SETTINGS}
  ${SECTIONS_WRAPPER_QUERY}
  query GetContact($slug: String!, $locale: SiteLocale!) {
    site: _site(locale: $locale) {
      ...SiteFields
    }
    general(locale: $locale) {
      ...GeneralFields
    }
    fields: contact(filter: { slug: { eq: $slug } }, locale: $locale) {
      # Contact Meta (SEO)
      slugs: _allSlugLocales(locale: $locale) {
        locale
        value
      }
      titles: _allTitleLocales(locale: $locale) {
        locale
        value
      }
      seoMetaTags: _seoMetaTags(locale: $locale) {
        attributes
        content
        tag
      }

      # Contact Fields (Content)
      title
      shortTitle
      intro {
        value
      }

      introImage {
        id
        responsiveImage(
          imgixParams: { auto: format, fit: crop, crop: focalpoint, w: "500", h: "500", q: "75" }
        ) {
          alt
          height
          src
          title
          width
        }
      }

      # Contact Components
      pageSettings {
        ...PageSettings
      }
      sections {
        ...SectionWrapperQuery
      }
    }
    offices: allOffices(
      first: 100
      filter: {
        parent: { exists: "false" }
        _locales: { allIn: [$locale] }
        hideOfficeFromOverview: { eq: false }
      }
      locale: $locale
      orderBy: title_ASC
    ) {
      id
      title
      slug
      officeLocations {
        officeAddress
      }
    }
  }
`;
